import { useEffect } from "react";
import { notifyPageView } from "../../analytics/useAnalyticsEventTracker";
import { stateType } from "../../state";
import { useStyles } from "../DataIngestion/DataIngestion";
import { ModelAnalysis } from "./ModelAnalysisBox";
import { ModelTrainingBox } from "./ModelTrainingBox";
import { ValueDropDown } from "./ValueDropDown";
import { setMetaTags } from "../../helpers/pageMeta";

export function ModelTraining({ state }: stateType) {
	const classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		notifyPageView("Model Training Page", window.location.pathname);
	}, []);
	return (
		<div className={classes.root}>
			<div className={classes.grid}>
				<div className={classes.title}>Model Training</div>
			</div>
			<div className={classes.grid}>
				<div className={classes.subTitle}>
					Train your Machine Learning models to understand your data
					and make predictions.
				</div>
			</div>

			<div className={classes.grid}>
				<div
					style={{
						height: "40px",
						width: "100%",
						display: "flex",
						flexDirection: "row",
						marginBottom: "0px",
						marginTop: "0px",
						zIndex: 100,
						marginLeft: "-40px",
					}}
				>
					<ValueDropDown state={state}></ValueDropDown>
				</div>
			</div>
			<div className={classes.grid}>
				<ModelTrainingBox state={state}></ModelTrainingBox>
			</div>
			<div className={classes.divider2}></div>

			{state.saveState.savedModels.length > 0 ? (
				<div className={classes.grid}>
					<div className={classes.title}>Model Analysis</div>
				</div>
			) : (
				<div></div>
			)}
			{state.saveState.savedModels.length > 0 ? (
				<div className={classes.grid}>
					<ModelAnalysis state={state}></ModelAnalysis>
				</div>
			) : (
				<div></div>
			)}
		</div>
	);
}
